export default __webpack_public_path__ + "50a0b52df5b4f573b28c100b9967dddc.png";